// Shared label helpers for the searchable participant / staff pickers.
export const participantLabel = (p) =>
  p ? (`${p.first_name || ''} ${p.last_name || ''}`.trim() || p.name || p.ndis_number || '') : '';

export const staffLabel = (s) => {
  if (!s) return '';
  const name = s.full_name || `${s.first_name || ''} ${s.last_name || ''}`.trim() || s.email;
  if (name) return name;
  // Dev/QA staff records whose linked user document is missing would otherwise
  // render as a blank row — always give the person something to read.
  if (s.employee_id) return `${s.employee_id} (no user record)`;
  const id = String(s.id || s.user_id || '');
  return id ? `Staff ${id.slice(-6)} (no user record)` : '';
};

export const labelFor = (list, id, fn) =>
  fn((list || []).find((x) => String(x.id ?? x.user_id ?? x._id) === String(id)));

export const PARTICIPANT_SEARCH_HINT = 'Search participants by name or NDIS number…';
export const STAFF_SEARCH_HINT = 'Search staff by name, email or employee ID…';
